import { put, call, delay, select } from "redux-saga/effects";
import NewsActions from 'stores/leadbest-official-website/news/actions';
import errorHandlerSaga from '../errorHandlerSaga';
import {
    getHomepageNews, getNews, getFeatureNews, getTags, getNewsDetails
} from 'services/leadbest-official-website/newsApi';

export function* getHomepageNewsSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(getHomepageNews, payload);
        yield put(NewsActions.getHomepagenewsSuccess(res));
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(NewsActions.getHomepagenewsError(errorHandler));
    }
}

export function* getNewsSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(getNews, payload);
        yield put(NewsActions.getNewsSuccess(res));
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(NewsActions.getNewsError(errorHandler));
    }
}

export function* getFeatureNewsSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(getFeatureNews, payload);
        yield put(NewsActions.getFeaturenewsSuccess(res));
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(NewsActions.getFeaturenewsError(errorHandler));
    }
}

export function* getTagsSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(getTags, payload);
        yield put(NewsActions.getTagsSuccess(res));
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(NewsActions.getTagsError(errorHandler));
    }
}

export function* getNewsDetailsSaga({ payload }: any): Generator<any, any, any> {
    try {
        let res: Promise<any> = yield call(getNewsDetails, payload);
        yield put(NewsActions.getNewsdetailsSuccess(res));
    } catch (error) {
        const errorHandler = yield errorHandlerSaga(error);
        yield put(NewsActions.getNewsdetailsError(errorHandler));
    }
}
